/* 50/30/20 Budget Planner — Ch. 3.
   Live editing of allocation %, line items per bucket, donut chart, projection. */
(function () {
  'use strict';
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  class BudgetPlanner {
    constructor(id) {
      this.el = document.getElementById(id); if (!this.el) return;
      var u = IT.url.read();
      this.state = {
        income: +u.inc || 1500,
        needsPct: +u.np || 50,
        wantsPct: +u.wp || 30,
        savePct:  +u.sp || 20,
        items: u.items ? JSON.parse(decodeURIComponent(u.items)) : {
          needs: [{ n: 'Transport', a: 80 }, { n: 'Food', a: 200 }, { n: 'Phone', a: 40 }],
          wants: [{ n: 'Games', a: 30 }, { n: 'Eating out', a: 60 }],
          save:  [{ n: 'Emergency fund', a: 100 }, { n: 'Investing', a: 60 }]
        }
      };
      this.render(); this.attach(); this.update();
    }

    render() {
      var s = this.state;
      this.el.innerHTML = `
        <div class="sim-layout">
          <div class="sim-controls">
            <div class="sim-field">
              <label class="sim-field__label"><span>Monthly income</span><span class="val" data-display="income">${fmt(s.income)}</span></label>
              <input type="range" data-state="income" min="100" max="10000" step="50" value="${s.income}">
            </div>
            <div class="sim-field">
              <label class="sim-field__label"><span>Needs %</span><span class="val" data-display="needsPct">${s.needsPct}%</span></label>
              <input type="range" data-state="needsPct" min="0" max="100" step="1" value="${s.needsPct}">
            </div>
            <div class="sim-field">
              <label class="sim-field__label"><span>Wants %</span><span class="val" data-display="wantsPct">${s.wantsPct}%</span></label>
              <input type="range" data-state="wantsPct" min="0" max="100" step="1" value="${s.wantsPct}">
            </div>
            <div class="sim-field">
              <label class="sim-field__label"><span>Save %</span><span class="val" data-display="savePct">${s.savePct}%</span></label>
              <input type="range" data-state="savePct" min="0" max="100" step="1" value="${s.savePct}">
            </div>
            <p data-out="totalwarn" class="amazon-disclaimer"></p>
          </div>
          <div class="sim-results">
            <div style="display:grid; grid-template-columns:1fr 1fr 1fr; gap:12px;">
              <div class="sim-result"><div class="sim-result-label" style="color:var(--yellow);">Needs</div><div style="font-family:var(--font-display); font-weight:700; font-size:22px;" data-out="needsTotal">$0</div></div>
              <div class="sim-result"><div class="sim-result-label" style="color:var(--text-secondary);">Wants</div><div style="font-family:var(--font-display); font-weight:700; font-size:22px;" data-out="wantsTotal">$0</div></div>
              <div class="sim-result"><div class="sim-result-label" style="color:var(--yellow-hover);">Save</div><div style="font-family:var(--font-display); font-weight:700; font-size:22px;" data-out="saveTotal">$0</div></div>
            </div>
            <div class="sim-chart-wrap" style="min-height:220px;"><canvas id="bp-chart"></canvas></div>
            <div class="sim-insight" data-out="projection"></div>

            ${this.bucketHTML('needs', 'Needs (rent, food, transport)', 'forest')}
            ${this.bucketHTML('wants', 'Wants (fun, eating out, subscriptions)', 'amber')}
            ${this.bucketHTML('save',  'Savings & investing goals', 'plum')}

            <div><button class="btn btn--outline btn--sm" data-print>Download PDF Summary</button></div>
          </div>
        </div>`;
      this.bindRanges();
    }
    bucketHTML(key, label, color) {
      var items = this.state.items[key];
      var rows = items.map((it, i) => `
        <div class="sim-debt" data-bucket="${key}" data-idx="${i}">
          <input type="text" data-field="n" value="${it.n}">
          <input type="number" data-field="a" value="${it.a}" min="0" style="width:100px; text-align:right;">
          <button class="remove" data-remove>Remove</button>
        </div>`).join('');
      var labelColor = color === 'forest' ? 'var(--yellow)' : (color === 'amber' ? 'var(--text-secondary)' : 'var(--yellow-hover)');
      return `
        <div>
          <p class="label" style="color:${labelColor}; margin:14px 0 8px;">${label}</p>
          <div data-bucket-list="${key}">${rows}</div>
          <button class="sim-add-btn" data-add="${key}">+ Add line item</button>
          <p class="sim-result__sub" style="margin-top:6px;">Total: <strong data-bucket-total="${key}">$0</strong> / <span data-bucket-cap="${key}">$0</span></p>
        </div>`;
    }
    bindRanges() {
      this.el.querySelectorAll('input[data-state]').forEach(input => {
        input.addEventListener('input', () => {
          var k = input.dataset.state, v = +input.value;
          this.state[k] = v;
          var l = this.el.querySelector(`[data-display="${k}"]`);
          if (l) l.textContent = (k.endsWith('Pct')) ? v + '%' : fmt(v);
          this.update();
        });
      });
    }
    attach() {
      this.el.addEventListener('input', e => {
        var row = e.target.closest('[data-bucket]');
        if (!row) return;
        var b = row.dataset.bucket, i = +row.dataset.idx, f = e.target.dataset.field;
        if (!f) return;
        this.state.items[b][i][f] = (f === 'a') ? +e.target.value : e.target.value;
        this.update();
      });
      this.el.addEventListener('click', e => {
        if (e.target.dataset.remove !== undefined) {
          var row = e.target.closest('[data-bucket]');
          this.state.items[row.dataset.bucket].splice(+row.dataset.idx, 1);
          this.render(); this.attach(); this.update();
        }
        if (e.target.dataset.add) {
          this.state.items[e.target.dataset.add].push({ n: 'New item', a: 0 });
          this.render(); this.attach(); this.update();
        }
        if (e.target.dataset.print !== undefined) window.print();
      });
    }
    update() {
      var s = this.state;
      // Normalise % to total 100 (just warn rather than force)
      var pctSum = s.needsPct + s.wantsPct + s.savePct;
      var $ = q => this.el.querySelector(q);
      $('[data-out="totalwarn"]').textContent = pctSum === 100 ? '' : `Allocation totals ${pctSum}% — should be 100%.`;
      var needsCap = s.income * s.needsPct / 100;
      var wantsCap = s.income * s.wantsPct / 100;
      var saveCap  = s.income * s.savePct  / 100;
      $('[data-out="needsTotal"]').textContent = fmt(needsCap);
      $('[data-out="wantsTotal"]').textContent = fmt(wantsCap);
      $('[data-out="saveTotal"]').textContent  = fmt(saveCap);

      ['needs', 'wants', 'save'].forEach(b => {
        var sum = s.items[b].reduce((a, it) => a + (+it.a || 0), 0);
        var cap = b === 'needs' ? needsCap : (b === 'wants' ? wantsCap : saveCap);
        var totEl = this.el.querySelector(`[data-bucket-total="${b}"]`);
        var capEl = this.el.querySelector(`[data-bucket-cap="${b}"]`);
        if (totEl) totEl.textContent = fmt(sum);
        if (capEl) capEl.textContent = fmt(cap);
        var rows = this.el.querySelectorAll(`[data-bucket="${b}"]`);
        rows.forEach(r => { r.style.borderColor = (sum > cap) ? 'var(--yellow-hover)' : 'var(--border)'; });
      });

      // Projection: invest savings at 8% for 30 years
      var monthlyR = 0.08 / 12, n = 360;
      var fv = saveCap * ((Math.pow(1 + monthlyR, n) - 1) / monthlyR);
      $('[data-out="projection"]').innerHTML =
        `If you invest your <strong>${fmt(saveCap)}</strong>/month savings at 8% for 30 years: <strong>${fmt(fv)}</strong>.`;

      this.renderChart(needsCap, wantsCap, saveCap);
      IT.url.write({ inc: s.income, np: s.needsPct, wp: s.wantsPct, sp: s.savePct, items: encodeURIComponent(JSON.stringify(s.items)) });
    }
    renderChart(n, w, sv) {
      if (!window.Chart) { setTimeout(() => this.renderChart(n, w, sv), 200); return; }
      var ctx = this.el.querySelector('#bp-chart');
      if (this._chart) this._chart.destroy();
      var T = window.IT_TOKENS;
      this._chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Needs', 'Wants', 'Save'],
          datasets: [{ data: [n, w, sv], backgroundColor: [T.yellow, T.blue, T.green], borderWidth: 1, borderColor: T.bgCard }]
        },
        options: {
          responsive: true, maintainAspectRatio: false, cutout: '65%'
        }
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => new BudgetPlanner('simulator-container'));
})();
